import React from "react";
import Layout from "../components/layout";
import BlogRoll from "../components/BlogRoll";
import Presentation from "../components/presentation";
// import { faChevronDown } from '@fortawesome/fontawesome-free-solid';
// import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import Head from "../components/head"
//import Quot from "../components/quote";


export default class BlogIndexPage extends React.Component {
    render() {
      return (
        <Layout>
          <Head />
          <div className="presentation">
            {/* <Quot /> */}
            <Presentation />
            {/* <div className="arrow">
              <FontAwesomeIcon icon={faChevronDown} />
            </div> */}
          </div>
          
          <h1>Latest Posts</h1>
          <section>
            <div className="content">
              <BlogRoll  />
            </div>
          </section>
        </Layout>
      )
    }
  }